<template lang="pug">
  y-chip.neutral200.pa-3.d-block
    .text-xs.neutral500--text.font-semibold.mb-3(v-if="showCurrentProgressText") Current progress
    .d-flex.align-center.justify-lg-space-between
      .text-md.text-sm.neutral700--text.font-semibold {{ pointCollected }} {{ pointShortForm ? 'pts' : 'points' }}
      .text-xs.neutral700--text {{ availableRewards.length }} {{ 'reward' | pluralize({count: availableRewards.length}) }} available to be redeemed
</template>

<script>

export default {
  props: {
    showCurrentProgressText: {
      type: Boolean
    },
    pointCollected: {
      type: Number,
      default: 0
    },
    pointShortForm: {
      type: Boolean,
    },
    availableRewards: {
      type: Array,
      default: () => ([])
    }
  },
}
</script>

<style scoped>
</style>